var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "class-name": "bulk-property-modal",
            "show-footer": false,
            "show-title": false,
          },
          on: { cancel: _vm.onCancel },
        },
        [
          _c("div", { staticClass: "bulk-property-modal-content" }, [
            _c(
              "div",
              { staticClass: "modal-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("edit_note"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Profil Alanı Ekleme")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "properties-wrapper" },
                  _vm._l(_vm.properties, function (prop, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "property-card" },
                      [
                        _c("div", { staticClass: "card-header" }, [
                          _c("div", { staticClass: "header-left" }, [
                            _c("div", { staticClass: "property-badge" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "property-label" }, [
                              _vm._v("Alan " + _vm._s(index + 1)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.properties.length > 1
                            ? _c(
                                "button",
                                {
                                  staticClass: "remove-button",
                                  attrs: { title: "Alanı kaldır" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeProperty(index)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("close"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c("label", { staticClass: "field-label" }, [
                                _vm._v("Alan Adı"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-select",
                                {
                                  staticClass: "property-select",
                                  attrs: {
                                    size: "large",
                                    placeholder: "Alan seçin...",
                                    "filter-option": _vm.filterOption,
                                    "show-search": "",
                                  },
                                  model: {
                                    value: prop.propertyId,
                                    callback: function ($$v) {
                                      _vm.$set(prop, "propertyId", $$v)
                                    },
                                    expression: "prop.propertyId",
                                  },
                                },
                                _vm._l(
                                  _vm.getAvailablePropertiesForIndex(index),
                                  function (contactProp) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: contactProp._id,
                                        attrs: { value: contactProp._id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(contactProp.name) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c("label", { staticClass: "field-label" }, [
                                _vm._v("Değer"),
                              ]),
                              _vm._v(" "),
                              [
                                "text",
                                "email",
                                "phone",
                                "number",
                                "url",
                              ].includes(_vm.getPropertyType(prop.propertyId))
                                ? _c("a-input", {
                                    attrs: {
                                      size: "large",
                                      type: _vm.getInputType(prop.propertyId),
                                      placeholder: _vm.getPlaceholder(
                                        prop.propertyId
                                      ),
                                    },
                                    model: {
                                      value: prop.value,
                                      callback: function ($$v) {
                                        _vm.$set(prop, "value", $$v)
                                      },
                                      expression: "prop.value",
                                    },
                                  })
                                : _vm.getPropertyType(prop.propertyId) ===
                                  "date"
                                ? _c("a-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "large",
                                      placeholder: "Tarih seçin...",
                                      format: "DD.MM.YYYY",
                                    },
                                    model: {
                                      value: prop.value,
                                      callback: function ($$v) {
                                        _vm.$set(prop, "value", $$v)
                                      },
                                      expression: "prop.value",
                                    },
                                  })
                                : _vm.getPropertyType(prop.propertyId) ===
                                  "dropdown"
                                ? _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "large",
                                        placeholder: "Seçenek seçin...",
                                      },
                                      model: {
                                        value: prop.value,
                                        callback: function ($$v) {
                                          _vm.$set(prop, "value", $$v)
                                        },
                                        expression: "prop.value",
                                      },
                                    },
                                    _vm._l(
                                      _vm.getPropertyOptions(prop.propertyId),
                                      function (option) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: option,
                                            attrs: { value: option },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(option) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm.getPropertyType(prop.propertyId) ===
                                  "json"
                                ? _c("prism-editor", {
                                    staticClass: "json-editor",
                                    attrs: {
                                      highlight: _vm.highlighter,
                                      "line-numbers": false,
                                    },
                                    model: {
                                      value: prop.value,
                                      callback: function ($$v) {
                                        _vm.$set(prop, "value", $$v)
                                      },
                                      expression: "prop.value",
                                    },
                                  })
                                : _c("a-input", {
                                    attrs: {
                                      size: "large",
                                      placeholder: "Değer girin...",
                                    },
                                    model: {
                                      value: prop.value,
                                      callback: function ($$v) {
                                        _vm.$set(prop, "value", $$v)
                                      },
                                      expression: "prop.value",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "add-more-button",
                    attrs: { ghost: "", block: "" },
                    on: { click: _vm.addProperty },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("add_circle_outline"),
                    ]),
                    _vm._v("\n                Yeni Alan Ekle\n            "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.onCancel } }, [
                  _vm._v("İptal"),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("check"),
                    ]),
                    _vm._v("\n                Alan Ekle\n            "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }